(function (window, angular, undefined) {

  var isIE11 = !!(navigator.userAgent.match(/Trident/) && !!navigator.userAgent.match(/rv:11/));

  var directivesModule = angular.module('mfTrainee.directives', [])

    .constant('hmClickDefaults', {
      prevent_default: true,
      swipe: false,
      drag: false,
      transform: false,
      tap: true,
      tap_double: false,
      hold: false
    })
    .constant('HM_OPTION_DEFAULTS', {
      // prevent the default event or not... might be buggy when false
      prevent_default: false,
      css_hacks: true,

      swipe: true,
      swipe_time: 500, //200? ms
      swipe_min_distance: 20, // pixels

      drag: true,
      drag_vertical: true,
      drag_horizontal: true,
      // minimum distance before the drag event starts
      drag_min_distance: 20, // pixels

      // pinch zoom and rotation
      transform: true,
      scale_treshold: 0.1,
      rotation_treshold: 15, // degrees

      tap: true,
      tap_double: true,
      tap_max_interval: 300,
      tap_max_distance: 10,
      tap_double_distance: 20,

      hold: true,
      hold_timeout: 500
    })
    .directive('hmClick', ['$parse', 'hmClickDefaults', '$timeout', function ($parse, hmClickDefaults, $timeout) {
      return function (scope, elm, attrs) {
        var fn = $parse(attrs['hmClick']);
        var defaults = hmClickDefaults;
        if (angular.isDefined(attrs.hmOptions))
          defaults = _.defaults(scope.hmOptions, hmClickDefaults);
        elm.hammer(defaults, 'tap').
          bind('tap', function (evt) {
            $timeout(function () {
              evt.stopPropagation();
              fn(scope, {$event: evt});
            });
          });
      };
    }])
    .directive('mfScrollyGrip', ['$window', function ($window) {
      return function (scope, elem, attrs) {
        // we need different values when do scroll height because font sizes
        // are different between browswer and ipad
        var isExpanded = false;
        var scrollerHeight = $window.isNativeIpadApp ? 30 : 20; // Need to fix this to use MobileHelper
        var scrollyGrip = $(attrs.mfScrollyGrip);
        var scrollyContainer = $(attrs.mfScrollyContainer);
        var scrollyHeader = $(attrs.mfScrollyHeader);
        var scrollyFooter = $(attrs.mfScrollyFooter);
        var scrollHeight;
        var rawElem;
        var hammerCaptureGrip = {prevent_default: true, drag: true, swipe: false, tap: true};
        var hammerCaptureTap = {prevent_default: false, drag: false, swipe: false, tap: true};

        elem.css('display', 'none');

        //Use timeout to force the DOM to draw and measure first.
        setTimeout(function () {
          elem.css('display', 'block');
          checkIfScrollable();
        }, 125);
        scrollyGrip.hammer(hammerCaptureGrip, 'tap').on('tap', function (e) {
          e.stopImmediatePropagation();
          onTap(e);
        });

        elem.hammer(hammerCaptureTap, 'tap').on('tap', onTap);

        angular.element($window).on('resize', onResize);

        scope.$on('$destroy', function () {
          elem.off();
          angular.element($window).off('resize', onResize);
        });

        function onTap(e) {
          isExpanded = !isExpanded;
          if (isExpanded)
            scrollyGrip.addClass('is-open');
          else
            scrollyGrip.removeClass('is-open');
          resizeHeight();
        }

        function onResize() {
          resizeHeight();
          checkIfScrollable();
        }

        function resizeHeight() {
          updateScrollHeight();
          var availableHeight = scrollyContainer.height() - scrollyHeader.outerHeight() - scrollyFooter.outerHeight()
            - scrollyGrip.outerHeight() - 30; // extra 30 pixels of padding
          var minHeight = parseInt(elem.css('minHeight'));
          var fullHeight = Math.min(availableHeight, scrollHeight);
          if (fullHeight == scrollHeight) fullHeight = scrollHeight - scrollerHeight;
          var newHeight = isExpanded ? fullHeight : minHeight;
          newHeight = Math.max(minHeight, newHeight);
          elem.css('height', newHeight);
          scrollyGrip.css('top', newHeight + $(scrollyGrip).height() - 2 + 'px');
        }

        function checkIfScrollable() {
          updateScrollHeight();
          var canExpand = (scrollHeight > rawElem.clientHeight);
          if (isExpanded && !canExpand) {
            isExpanded = false;
            scrollyGrip.removeClass('is-open');
            resizeHeight();
          }
          scrollyGrip.toggle(canExpand);
          if (canExpand)
            elem.parent().css('margin-bottom', '40px');
          else
            elem.parent().css('margin-bottom', '0');
        }

        function updateScrollHeight() {
          rawElem = elem[0];
          scrollHeight = rawElem.scrollHeight;
        }
      };
    }])

    .directive('mfFillHeight', ['$window', function ($window) {
      return function (scope, elem, attrs) {
        var container = $(attrs.mfFillContainer);
        var children = container.children();

        angular.element($window).on('resize', onResize);

        scope.$on('$destroy', function () {
          angular.element($window).off('resize', onResize);
        });

        elem.css('display', 'none');
        onResize();

        //Use timeout to force the DOM to draw and measure first.
        setTimeout(function () {
          elem.css('display', 'block');
          onResize();
        }, 125);

        function onResize() {
          var availableHeight = angular.element($window).height();
          var maxHeight = parseInt(container.css('max-height'));
          var containerHeight = Math.min(availableHeight, maxHeight);
          if (isIE11)
            containerHeight = containerHeight - 3;
          else if (window.BrowserDetect && window.BrowserDetect.browser == 'Explorer' && window.BrowserDetect.version == 8) {
            var borderTop = parseInt($(container).css('border-top-width')) || 0;
            var borderBottom = parseInt($(container).css('border-bottom-width')) || 0;
            containerHeight = containerHeight - borderTop - borderBottom;
          }

          var otherChildrenHeight = 0;
          _.each(children, function (child) {
            if (isDirectiveElem(child) || $(child).css('display') == 'none') return;
            otherChildrenHeight = otherChildrenHeight + $(child).outerHeight();
          });
          elem.css('height', (containerHeight - otherChildrenHeight) + 'px');
        }

        function isDirectiveElem(child) {
          return (elem[0].id && child.id == elem[0].id) || (elem[0].className && elem[0].className == child.className);
        }
      };
    }])

    .directive('bsModal', ['$parse', function ($parse) {
      return function (scope, elem, attrs) {
        scope.$watch(attrs.bsModal, function (value) {
          if (!value) {
            elem.modal('hide').removeData('modal');
          } else {
            elem.removeData('modal').modal({
              show: !!value,
              backdrop: value ? value.backdrop : true,
              keyboard: false
            });
          }
        });

        var getModalData = $parse(attrs.bsModal);
        elem.on('hidden', function (e) {
          getModalData.assign(scope, null);
        });
        elem.on('touch click', '[data-dismiss-modal]', function (e) {
          var modalData = getModalData(scope);
          var action = e.currentTarget.attributes['data-dismiss-modal'].value;
          elem.modal('hide');
          scope.$apply(function () {
            if (modalData[action])
              modalData[action](action);
          });
        });

        scope.$on('$destroy', function () {
          elem.off();
        });
      };
    }])

    // old angular-strap directive but works with bootstrap select
    .directive('bsSelect', [ '$timeout', function ($timeout) {
      var NG_OPTIONS_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?(?:\s+group\s+by\s+(.*))?\s+for\s+(?:([\$\w][\$\w\d]*)|(?:\(\s*([\$\w][\$\w\d]*)\s*,\s*([\$\w][\$\w\d]*)\s*\)))\s+in\s+(.*)$/;
      return {
        restrict: 'A',
        require: '?ngModel',
        link: function postLink(scope, element, attrs, controller) {
          // TODO: Iverson fix for dashboard
          return;
          var options = scope.$eval(attrs.bsSelect) || {};
          $timeout(function () {
            if(element.selectpicker)
              element.selectpicker(options);
            element.next().removeClass('ng-scope');
          });
          if (controller) {
            scope.$watch(attrs.ngModel, function (newValue, oldValue) {
              if (!angular.equals(newValue, oldValue)) {
                if(element.selectpicker)
                  element.selectpicker('refresh');
              }
            });
          }
        }
      };
    }]);

  function normalizeDirectiveName(name) {
    return name.substr(0, 1).toUpperCase() + name.substr(1, name.length - 1).replace('-', '');
  }

// Event directives
  var events;
  events = 'loadedmetadata timeupdate loadeddata play progress ended keyup'.split(' ');
  angular.forEach(events, function (name) {
    var directiveName = 'mf' + normalizeDirectiveName(name);
    directivesModule.directive(directiveName, ['$parse', '$window', function ($parse, $window) {
      return function (scope, elm, attrs) {
        var fn = $parse(attrs[directiveName]);

        elm.on(name.toLowerCase(), function (evt) {
          scope.$apply(function () {
            fn(scope, {$event: evt});
          });
        });

        scope.$on('$destroy', function () {
          elm.off();
        });
      };
    }]);
  });

// Touch/mouse event directives
  events = 'touchstart-mousedown touchend-mouseup touchmove-mousemove'.split(' ');
  angular.forEach(events, function (name) {
    var directiveName = 'mf' + normalizeDirectiveName(name);
    var namePieces = name.split('-');
    var touchName = namePieces[0];
    var mouseName = namePieces[1];
    directivesModule.directive(directiveName, ['$parse', '$window', function ($parse, $window) {
      return function (scope, elm, attrs) {
        var fn = $parse(attrs[directiveName]);
        var isTouch = ("ontouchstart" in document.documentElement);
        var eventName = isTouch ? touchName : mouseName;
        elm.on(eventName.toLowerCase(), function (evt) {
          scope.$apply(function () {
            fn(scope, {$event: evt});
          });
        });

        scope.$on('$destroy', function () {
          elm.off();
        });

      };
    }]);
  });

})(window, window.angular);
